<template>
    <div class="map_category_wrap">
        <div class="map_category lifemap">
            <PopulationSelectPane init-top-tab-code="age" />

            <div class="inner_box02">
                <div v-for="facCategory in facCategoryCodeList" :key="facCategory.commonCode">
                    <div :class="['menu01',  facCategory.commonCodeEngNm === selectedFacCategory ? 'on' : 'off']">
                        <a href="#" @click.prevent="selectFacCategory(facCategory.commonCodeEngNm, true)">{{ facCategory.commonCodeNm }}</a>
                    </div>
                    <div :class="['menu01_s',  facCategory.commonCodeEngNm === selectedFacCategory ? 'on' : 'off']">
                        <ul class="scroll9">
                            <li v-for="facRepo in facRepoMap[facCategory.commonCode]" :key="facRepo.amnDataSqno">
                                <input type="checkbox" :id="'chk' + facRepo.dataKdSqno"
                                    @click="selectFac(facRepo.dataKdSqno)"
                                    :class="'ico_chk ic' + facRepo.dataKdSqno"
                                    :name="facCategory.commonCodeEngNm"
                                    :value="facRepo.dataKdSqno" ref="facRepo">
                                <label :for="'chk' + facRepo.dataKdSqno">&nbsp;</label>
                                <label :for="'chk' + facRepo.dataKdSqno">
                                {{ facRepo.dataKdScrnTit }}
                                ({{ facDataMap[facRepo.dataKdSqno] ? facDataMap[facRepo.dataKdSqno].length : '' }})
                                </label>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import PopulationSelectPane from "@/components/PopulationSelectPane.vue";

export default {
    name: 'LifemapSelectPane',
    computed: {
        ...mapGetters({
            facCategoryCodeList: 'getFacCategoryCodeList',
            selectedFacCategory: 'getSelectedFacCategory',
            selectedFacSqnos: 'getSelectedFacSqnos',
            facRepoMap: 'getFacRepoMap',
            facDataMap: 'getFacDataMap',
        }),
    },
    created() {
        // 시설 데이터 로딩 완료 시
        this.$eventBus.$once('LifemapApp::fac-data-loaded', () => {
            // 시설 초기 선택
            this.selectFacCategory('Welfare', true);
        });
    },
    methods: {
        selectFacCategory(selectedFacCategory, facDefaultChecked) {
            if(this.selectedFacCategory !== selectedFacCategory) {
                this.$store.dispatch("SET_SELECTED_FAC_CATEGORY", selectedFacCategory);
                if(facDefaultChecked) {
                    let facRepoInput = this.$refs.facRepo;
                    // 모두 비 선택 상태로
                    for(let i = 0; i < facRepoInput.length; i++) {
                        facRepoInput[i].checked = false;
                    }

                    // 첫번째 항목 체크
                    document.querySelector("input[name=" + selectedFacCategory + "]").checked = true;
                    this.selectFac();
                }
            }
        },
        selectFac(facSqno) {
            let facRepoInput = this.$refs.facRepo;
            let selectedFacSqnos = [];
            let lastVal = "";
            for(let i = 0; i < facRepoInput.length; i++) {
                let facInputVal = Number(facRepoInput[i].value);
                if(facRepoInput[i].checked) {
                    if(facSqno !== facInputVal) {
                        selectedFacSqnos.push(facInputVal);
                    } else {
                        lastVal = facSqno;
                    }
                }
            }
            if(lastVal !== "") {
                selectedFacSqnos.push(lastVal);
            }

            this.$store.dispatch("SET_SELECTED_FAC_SQNOS", selectedFacSqnos);
        },
    },
    components: {
        PopulationSelectPane,
    }
}
</script>
